const config: Highcharts.Options = {
  chart: {
    type: 'column',
    backgroundColor: null as any,
    style: {
      fontFamily: 'Inter',
    },
  },
  colors: ['#01589F'],
  title: {
    text: null as any,
  },
  legend: {
    enabled: true,
    symbolRadius: 0,
    itemStyle: {
      fontFamily: 'Inter',
      fontWeight: '500',
      fontSize: '11px',
      lineHeight: '16px',
      color: '#6F7086',
    },
  },
  tooltip: {
    enabled: true,
  },
  credits: {
    enabled: false,
  },
  plotOptions: {
    series: {
      dataLabels: {
        enabled: false,
      },
      animation: false,
    },
    column: {
      stickyTracking: false,
      dragDrop: {
        draggableY: true,
      },
      dataLabels: {
        enabled: true,
        inside: true,
        verticalAlign: 'top',
        style: {
          fontFamily: 'Inter',
          fontWeight: '500',
          fontSize: '11px',
          lineHeight: '16px',
          color: '#fff',
          textOutline: 'none',
        },
      },
    },
  },
  series: [
    {
      name: 'Sales',
      type: 'column',
      color: '#01589F',
      data: [1, 2, 5, 4, 8, 9],
    },
  ],
  xAxis: {
    gridLineColor: 'transparent',
    categories: ['1', ' 5', '10', '15', '20', '25'],
    lineColor: '#CECEDC',
    title: {
      text: '',
      style: {
        fontFamily: 'Inter',
        fontWeight: '500',
        fontSize: '13px',
        lineHeight: '16px',
        color: '#ADADBF',
      },
    },
    labels: {
      style: {
        fontFamily: 'Inter',
        fontWeight: '500',
        fontSize: '11px',
        lineHeight: '16px',
        color: '#ADADBF',
      },
    },
    opposite: false,
    reversed: false,
  },
  yAxis: {
    gridLineWidth: 0,
    lineWidth: 1,
    lineColor: '#CECEDC',
    title: {
      text: '',
      style: {
        fontFamily: 'Inter',
        fontWeight: '500',
        fontSize: '13px',
        lineHeight: '16px',
        color: '#ADADBF',
      },
    },
    labels: {
      style: {
        fontFamily: 'Inter',
        fontWeight: '500',
        fontSize: '11px',
        lineHeight: '16px',
        color: '#ADADBF',
      },
    },
    opposite: false,
    reversed: false,
  },
};

export default config;
